import Vue from "vue";
import AppConfig from "@Region/Scripts/Config/AppConfig";
import { router } from "@Region/Scripts/Config/RouteConfig";
import { store } from "@Region/Scripts/Config/StoreConfig";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "CookieToast", "Region"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.setNavigation();
        this.setBackgroundColor();
        this.setAnalytics();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static setNavigation() {
        let app = document.getElementById("body"),
            header = document.getElementById("Header"),
            expOpen = header?.querySelectorAll(".button[data-exp='open']"),
            expClose = header?.querySelectorAll(".button[data-exp='close']"),
            backMenu = header?.querySelectorAll(".backmenu"),
            expMenu = document.getElementById("OpenMenu");

        if (!header) { return; }

        for (const button of expOpen) {
            button.addEventListener("click", e => {
                let targetElement = <HTMLElement>e.target;
                let parentElement = targetElement.parentElement;
                app.classList.add("overflow");
                header.classList.add("exp-open");
                header.querySelectorAll(".item[data-type]").forEach(doc => doc.classList.remove("show"));
                header.querySelector(".item[data-type=" + parentElement.dataset.type + "]").classList.add("show");
                header.querySelectorAll(".item[data-type] .button.selected").forEach(doc => doc.classList.remove("selected"));
                targetElement.classList.add("selected");
            });
        }

        for (const button of expClose) {
            button.addEventListener("click", e => {
                closeAll();
            });
        }

        header.addEventListener('click', function (e) {
            var targetElement = <HTMLElement>e.target;

            if (!targetElement.closest('.app-header .container')) {
                closeAll();
            }
        });

        expMenu.addEventListener('click', function (e) {
            header.classList.add("menu-open");
            app.classList.add("overflow");
            header.querySelector(".item[data-type='search'] .exp").classList.remove("hden");
        });

        for (const button of backMenu) {
            button.addEventListener("click", e => {
                header.classList.remove("exp-open");
            });
        }

        function closeAll() {
            app.classList.remove("overflow");
            header.classList.remove("exp-open");
            header.querySelectorAll(".item[data-type]").forEach(doc => doc.classList.remove("show"));
            header.querySelectorAll(".item[data-type] .button.selected").forEach(doc => doc.classList.remove("selected"));
            header.classList.remove("menu-open");
        }


        window.addEventListener("scroll", function () {
            if (window.scrollY > 0) {
                header.classList.add("minify");
                header.classList.add("hide");
            } else {
                header.classList.remove("minify");
                header.classList.remove("hide");
            }
        });

        let posizioneScroll = window.pageYOffset;

        window.addEventListener("scroll", function () {
            if (window.pageYOffset < posizioneScroll) {
                header.classList.remove("hide");
            }
            posizioneScroll = window.pageYOffset;
        });
    }

    private static setBackgroundColor() {
        window.addEventListener("scroll", (event) => {
            let panel = document.querySelectorAll(".layout"),
                header = document.getElementById("Header"),
                scroll = window.scrollY + (window.screen.height / 4);

            for (var i = 0; i < panel.length; i++) {
                let thisPanel = panel[i];

                if ((<HTMLElement>thisPanel).offsetTop <= scroll && (<HTMLElement>thisPanel).offsetTop + (<HTMLElement>thisPanel).offsetHeight > scroll) {
                    header?.classList.remove("light-layout");
                    header?.classList.remove("dark-layout");
                    header?.classList.add((<HTMLElement>thisPanel).dataset.layout + "-layout");
                }
            };
        });
    }

    private static setAnalytics() {
        let gaEventEditorItems = document.querySelectorAll(".editor a");
        for (const item of gaEventEditorItems) {
            item.addEventListener("click", x => {
                GTagHelper.sendEvent("click", "link", item.getAttribute("href"))
            });
        }

        let dataGaeventLinkTrue = document.querySelectorAll(".ga-event");
        for (const item of dataGaeventLinkTrue) {
            if (item) {
                item.addEventListener("click", function (event) {
                    GTagHelper.sendEvent(
                        this.getAttribute("data-ganame") ? this.getAttribute("data-ganame") : "click",
                        this.getAttribute("data-gacategory"),
                        this.getAttribute("data-galabel") === "link" ? this.getAttribute("href") : this.getAttribute("data-galabel"),
                    );
                });
            }
        }
    }

    public static setGallery() {
        (<any>window).Fancybox.bind("[data-fancybox='gallery']", {
            dragToClose: false,
            caption: (fancybox, slide) => {
                const caption = slide.caption || "";
                return caption;
            },
            Images: {
                zoom: false,
            },
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close'],
                },
            },
            Thumbs: {
                type: 'classic',
            },
        });
    }
}